var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { TEN_SECONDS } from "@common/communication";
let default_1 = class default_1 extends Vue {
    constructor() {
        super(...arguments);
        this.username = "";
        this.otp = "";
        this.password = "";
        this.confirmPassword = "";
    }
    onOtp() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.$refs.phone.valid())
                return this.username;
            return undefined;
        });
    }
    send() {
        return __awaiter(this, void 0, void 0, function* () {
            yield post('/api/Login/Forget', {
                Username: this.username,
                Password: this.password,
                OTP: this.otp,
            }, TEN_SECONDS);
            yield this.alert("請用新密碼重新登入", "重設密碼成功", 'success');
            this.$router.replace('/');
        });
    }
};
__decorate([
    Inject()
], default_1.prototype, "alert", void 0);
__decorate([
    Prop(String)
], default_1.prototype, "callback", void 0);
default_1 = __decorate([
    Component
], default_1);
export default default_1;
